import {Event} from "@api/models/Event";
import {AsyncDecl, GroupDecl, NestedDecl, ValidationDecl} from "vue/types/options";
import {required} from "vuelidate/lib/validators";

export const validationRules: Record<keyof Event, ValidationDecl | GroupDecl | AsyncDecl | NestedDecl> = {
    title: {
        required
    },
    beginAt: {
        required
    },
    endAt: {
        required
    }
}
